module.exports = __webpack_public_path__ + "img/three2Red.0ac742b6.jpg";